function validateStrongPassword(value, t) {
  if (!value) {
    return Promise.reject(t("form_validation.cannot_be_blank"))
  }
  const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/
  if (!strongPasswordRegex.test(value)) {
    return Promise.reject(t("form_validation.strong_password"))
  }
  return Promise.resolve()
}

export { validateStrongPassword }
